var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentKing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4375 115.266V129.406H36.6875V115.266H38.4375ZM27.1406 121.281C27.1328 118.234 28.6875 116.297 30.8281 116.297C32.9453 116.297 34.5078 118.234 34.5156 121.281C34.5078 124.352 32.9453 126.281 30.8281 126.281C28.6875 126.281 27.1328 124.352 27.1406 121.281ZM28.8125 121.281C28.8125 123.453 29.6328 124.711 30.8281 124.719C32.0156 124.711 32.8281 123.453 32.8281 121.281C32.8281 119.125 32.0156 117.859 30.8281 117.859C29.6328 117.859 28.8125 119.125 28.8125 121.281ZM55.6094 116.125V117.391C55.6016 118.711 55.6016 120.156 55.2344 122.156H57.1875V123.562H51.5781V129.406H49.8281V123.562H44.3125V122.156H53.4688C53.8594 120.234 53.875 118.789 53.875 117.531H45.8281V116.125H55.6094ZM69.9688 124.281V129.391H68.2344V125.656H60.3438V124.281H69.9688ZM58.3281 119.469C58.3281 117.469 59.9297 116.031 62.0625 116.047C63.2266 116.039 64.2422 116.477 64.9062 117.219H68.2344V115.266H69.9688V123.609H68.2344V121.734H64.9219C64.25 122.484 63.2344 122.938 62.0625 122.938C59.9297 122.938 58.3281 121.5 58.3281 119.469ZM59.9844 119.469C59.9844 120.695 60.8516 121.461 62.0625 121.469C63.2188 121.461 64.1016 120.695 64.1094 119.469C64.1016 118.289 63.2188 117.508 62.0625 117.516C60.8516 117.508 59.9844 118.289 59.9844 119.469ZM65.6562 120.328H68.2344V118.641H65.6641C65.7266 118.906 65.7656 119.18 65.7656 119.469C65.7656 119.766 65.7266 120.055 65.6562 120.328ZM81.8125 116.438V117.844H78.0312V121.5C79.6797 121.492 80.9219 121.414 82.3125 121.141L82.4688 122.547C80.7969 122.852 79.375 122.922 77.2812 122.922H76.3125V116.438H81.8125ZM77.4844 127.984C80.3125 127.578 82.125 125.992 82.1406 124.359V123.891H83.875V124.359C83.8672 125.992 85.6797 127.578 88.5469 127.984L87.8125 129.328C85.6016 128.961 83.875 127.922 83.0078 126.508C82.1406 127.922 80.3984 128.961 78.2031 129.328L77.4844 127.984ZM83.0938 123.312V115.516H84.7188V118.766H86.1875V115.266H87.8438V124.578H86.1875V120.188H84.7188V123.312H83.0938ZM100.922 115.859V116.797C100.93 117.719 100.93 118.891 100.633 120.359H102.5V121.734H89.5938V120.359H98.8828C99.1406 119.07 99.1797 118.07 99.1875 117.234H91.1875V115.859H100.922ZM91.0781 124.219V122.859H100.906V126.688H92.8281V127.891H101.266V129.25H91.0938V125.359H99.1719V124.219H91.0781ZM114.609 115.281V119H116.516V120.438H114.609V124.188H112.875V115.281H114.609ZM103.391 122.125C104.414 122.125 105.602 122.117 106.844 122.086V121C105.219 120.75 104.148 119.758 104.156 118.391C104.148 116.805 105.594 115.727 107.688 115.719C109.758 115.727 111.219 116.805 111.234 118.391C111.219 119.742 110.172 120.719 108.594 120.992V122.016C109.773 121.953 110.953 121.852 112.047 121.703L112.203 122.922C109.258 123.43 105.992 123.477 103.578 123.484L103.391 122.125ZM105.172 126.875C105.164 125.273 106.977 124.352 109.938 124.359C112.875 124.352 114.68 125.273 114.688 126.875C114.68 128.43 112.875 129.375 109.938 129.375C106.977 129.375 105.164 128.43 105.172 126.875ZM105.781 118.391C105.766 119.258 106.531 119.789 107.688 119.797C108.82 119.789 109.586 119.258 109.594 118.391C109.586 117.531 108.82 117.031 107.688 117.031C106.531 117.031 105.766 117.531 105.781 118.391ZM106.875 126.875C106.867 127.625 107.977 128.031 109.938 128.031C111.844 128.031 112.953 127.625 112.969 126.875C112.953 126.086 111.844 125.68 109.938 125.672C107.977 125.68 106.867 126.086 106.875 126.875Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.02 49.0005C119.02 75.5258 97.5258 97.0205 71.0005 97.0205C44.4751 97.0205 22.9805 75.5258 22.9805 49.0005C22.9805 22.4751 44.4751 0.980469 71.0005 0.980469C97.5258 0.980469 119.02 22.4751 119.02 49.0005Z",
    fill: "url(#paint0_linear_1275_5297)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.49 48.9999C113.49 72.4668 94.4668 91.4905 70.9999 91.4905C47.533 91.4905 28.5093 72.4668 28.5093 48.9999C28.5093 25.533 47.533 6.50933 70.9999 6.50933C94.4668 6.50933 113.49 25.533 113.49 48.9999Z",
    stroke: "#FFC25D",
    strokeWidth: 2.56553
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5297)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3377 51.4213C43.983 37.2487 54.3519 24.6653 68.5245 23.3106C70.1658 23.1543 71.8071 23.1543 73.4485 23.3106C87.6211 24.6914 98.016 37.2748 96.6613 51.4734C95.4108 64.7081 84.2863 74.7905 70.9995 74.7905C66.6748 74.7905 62.4022 73.6702 58.6245 71.586C58.338 71.4037 57.9732 71.3776 57.6606 71.4558L48.9851 74.061C48.5161 74.1913 48.0472 74.1913 47.5783 74.061C46.2756 73.6702 45.5462 72.3155 45.9369 71.0129L48.5422 62.3374C48.6204 62.0247 48.5943 61.66 48.4119 61.3734C46.7185 58.2992 45.6764 54.9124 45.3377 51.4213ZM62.3791 48.9985C62.3791 51.0272 60.7345 52.6719 58.7057 52.6719C56.6769 52.6719 55.0323 51.0272 55.0323 48.9985C55.0323 46.9697 56.6769 45.325 58.7057 45.325C60.7345 45.325 62.3791 46.9697 62.3791 48.9985ZM71.0025 52.6719C73.0313 52.6719 74.6759 51.0272 74.6759 48.9985C74.6759 46.9697 73.0313 45.325 71.0025 45.325C68.9738 45.325 67.3291 46.9697 67.3291 48.9985C67.3291 51.0272 68.9738 52.6719 71.0025 52.6719ZM86.947 48.9985C86.947 51.0272 85.3023 52.6719 83.2736 52.6719C81.2448 52.6719 79.6002 51.0272 79.6002 48.9985C79.6002 46.9697 81.2448 45.325 83.2736 45.325C85.3023 45.325 86.947 46.9697 86.947 48.9985Z",
    fill: "#FFC25D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5297",
    x: 27.2266,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5297"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5297",
    x: 45.2188,
    y: 23.1934,
    width: 51.5605,
    height: 52.6229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5297"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5297",
    x1: 37.6805,
    y1: 11.4338,
    x2: 107.75,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentKing);
export default __webpack_public_path__ + "static/media/CommentKing.5e594b2ed2558e23bfdab534a9c1b789.svg";
export { ForwardRef as ReactComponent };